/* eslint-disable @typescript-eslint/no-require-imports */
/**
 *
 * @file i18n.ts
 * @description Utility file which exports a translate function
 *
 * @copyright (C) Copyright 2026, Judi - All Rights Reserved
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const en = require("./locales/en.json");
const es = require("./locales/es.json");

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "es"],
    // we init with resources
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: "en",
    debug: true,
    nsSeparator: false,
    keySeparator: ".",
    detection: {
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
